import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'

import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";

import img1 from "../media/Img-1.svg";
import img2 from "../media/Img-2.svg";
import img3 from "../media/Img-3.svg";


import logo from "../../common/media/cc_logo_white.svg";
import logo_merchant from "../media/Ela-Logo.png"; // use here or from cloudinary
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getMerchantCodeWithPrefix } from '../../../tools/MyCCMerchantLinkGenerator';
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';

const LandingPage = ({ merchantCode, fetchedImpact }) => {


    return (
        <div>
            <div className="center p-3">
                <img src={logo_merchant} style={{ height: '60px' }} />
            </div>
            <div className="h-85vh w-100 position-relative img-cover hero-img vertical-align-parent" >
                <div className="container color-white text-left vertical-align">
                    <div className="mobile-hide">
                        <div className="mw-720px">
                            <h1 className="mb-4 text-shadow mt-0">We’re going Climate Positive for the planet</h1>
                            <h3 className="mb-3 text-shadow"></h3>
                        </div>

                        <div className="d-flex">
                            <p className="mr-2 mt-1 mb-0">Powered By</p>
                            <div>
                                <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logo} /></a>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show text-center">
                        <h2 className="mb-4 text-shadow mt-0">We’re going Climate Positive for the planet</h2>
                    </div>
                </div>
            </div>
            <div className="mobile-show">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <p className="mr-2 font-bold mt-1 mb-0">Powered By</p>
                        <div>
                            <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="content" className="py-6 bg-secondary">
                <div className="container text-center">
                    <div className="row mb-4">
                        <div className="col-7 d-grid mobile-hide">
                            <div className="img-cover ml-5 handbag-bg">
                                <img style={{top: "36px", left: "-48px"}} className="position-absolute shadow-lg" src={`https://res.cloudinary.com/carbonclick/image/upload/v1615096993/Ela%20Handbags/img-1_e0ykwt.png`} />
                            </div>
                        </div>
                        <div className="col-5 d-grid text-left">
                            <div className="px-3 py-4">
                                <h2 className="font-bold">Working Together for a Greener Future</h2>
                                <p>ela has collaborated with Michif visual artist Christi Belcourt on an exclusive Editor's Pouch to raise funds for Oceana Canada.<br/><br/>In support of the collaboration, we are pleased to announce that we have partnered with CarbonClick, a carbon offset organization dedicated to creating a greener planet.<br/><br/>We have offset the entire program from start to finish to make the entire lifecycle carbon neutral. Here, at home in Canada, our contribution will go towards preserving the forests of the Great Lakes.</p>
                                <div className="mobile-show">
                                    <img className="center mw-100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1615096993/Ela%20Handbags/img-1_e0ykwt.png`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="py-5" style={{marginTop: "-6rem"}}>
                <div className="impact-section container text-center">
                    <div className="bg-grey px-3 py-5">
                        <div className="row text-center">
                            <div className="col-7 mb-3 mobile-border-0 color-primary" style={{ borderRight: "4px solid" }}>
                                <h2 className="mt-3 color-tertiary">500 Handbags</h2>
                                <h5 className="color-primary font-bold">MADE CLIMATE POSITIVE</h5>
                            </div>
                            <div className="col-5 mb-3">
                                <h2 className="mt-3">7,500 kg</h2>
                                <h5 className="color-primary font-bold">CO2 OFFSET</h5>
                            </div>
                        </div>
                        <div className="pt-3">
                            <a href="https://my.carbon.click/transaction/25ac01aa-2613-49cd-9c16-f81cb00f9b08" target="_blank" className="w-240px btn btn-secondary">Trace Our Impact</a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-6">
                <div className="container">
                    <div className="center">
                        <h3 className="mb-4">What are we doing to address climate change?</h3>
                        <div className="row">
                           <div className="col-4">
                                <div className="mb-3">
                                    <img src={img1} />
                                </div>
                                <h4 className="color-primary">Sustainability Matters</h4>
                                <p>We love and appreciate the environment as much as we do beautiful design, so we decided to bid adieu to leather and say hello to alternative, cruelty-free vegan materials.</p>
                           </div>
                           <div className="col-4">
                           <div className="mb-3">
                                    <img src={img2} />
                                </div>
                                <h4 className="color-primary">Humble Luxury</h4>
                                <p>With modern fabrications and textiles, quality and accessibility can coexist. We believe that shopping affordably doesn't have to mean compromising on aesthetic.</p>
                           </div>
                           <div className="col-4">
                                <div className="mb-3">
                                    <img src={img3} />
                                </div>
                                <h4 className="color-primary">Charitable Collaborations</h4>
                                <p>We support causes that are meaningful to you and to the Global community by collaborating Holt Renfrew's H Project and CarbonClick.</p>
                           </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="sustainability-section container">
                   <div className="row">
                        <div className="col-md-8">
                            <div className="bg-grey-dark color-white text-right p-5">
                                <div className="mobile-hide pr-5 py-5">
                                    <h1 className="m-0">Sustainability</h1>
                                    <h1 className="m-0">Matters</h1>
                                    <p>We are bridging the gap between great design and accessible fashion and redefining the concept of luxury. We design timeless pieces that are crafted from vegan materials with the goal to make sustainability and animal-safe products the new normal.</p>
                                    <p>We reduced our environmental impact without compromising our aesthetic and quality so that you could have a choice that not only looks great, but also feels great to wear.</p>
                                </div>
                                <div className="mobile-show text-left">
                                <img className="mb-3 w-100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1615096993/Ela%20Handbags/Portrait_irrha4.png`} />
                                    <h3>Sustainability Matters</h3>
                                    <p>We are bridging the gap between great design and accessible fashion and redefining the concept of luxury. We design timeless pieces that are crafted from vegan materials with the goal to make sustainability and animal-safe products the new normal.</p>
                                    <p>We reduced our environmental impact without compromising our aesthetic and quality so that you could have a choice that not only looks great, but also feels great to wear.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-4 sustainability-img-container">
                            <img className="mobile-hide h-320px shadow-lg" src={`https://res.cloudinary.com/carbonclick/image/upload/v1615096993/Ela%20Handbags/Portrait_irrha4.png`} />
                        </div>
                   </div>
                </div>
            </section>


            <section className="bg-grey-light py-5">
                <div className="container">
                    <div className="center">
                        <h3 className="font-bold mt-0 mb-4">Feeling Inspired?</h3>
                        <p>Make a difference by offsetting your personal carbon emissions with CarbonClick</p>
                        <div className="">
                            <a href={`https://my.carbon.click/${getMerchantCodeWithPrefix(merchantCode)}/subscribe`} target="_blank" className="btn btn-primary w-240px mb-3">Offset My Life</a>
                        </div>
                    </div>
                </div>
            </section>


            <div className="py-6">
                <div className="container text-center">
                    <h3 className="font-bold mb-4">Climate Friendly FAQs</h3>
                    <div className="mb-3 center text-left mw-800px">
                        <Accordian title={"What is a carbon offset?"} >A carbon credit is what is bought and sold when dealing with voluntary carbon offsets. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) or the Emissions Trading Register (New Zealand).</Accordian>
                        <Accordian title={"What does carbon offsetting do?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO2 from the atmosphere.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                        <Accordian title={"How do I know the offset is trustworthy?"} >CarbonClick is committed to making carbon offsetting safe and trustworthy, we do this by tracing every transaction to the projects it supported so you can see the retirement certificates for every kg of CO2 offset. The trace link is sent in every purchase confirmation email, and can also be found on our website.</Accordian>
                    </div>
                </div>
            </div>


            {/*<div className="bg-green-light py-6">
                <div className="container text-center">
                    <div className="mb-5 center mw-600px">
                        <h2 className="font-light">Make a difference in fighting climate change</h2>
                        <p>Purchase a subscription to make an ongoing, traceable difference. We&apos;ll show you how your positive impacts grow each month.</p>
                    </div>

                    country && <PlansList
                        selectedPlan={selectedPlan}
                        onSelectedPlanChange={setSelectedPlan}
                        planChosen={planChosen}
                        country={country}
                        setLocationModalVisible={setShowModal}
                    />}
                </div>
            </div>*/}


            <div className="w-100 img-cover footer-img py-6 bg-primary" >
                <div className="container color-white py-5">
                    <p><b>Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div>
                                <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LandingPage;